module.exports = __webpack_public_path__ + "static/media/shengdiao018.fdfd90dc.jpg";